import React from "react"
import fb_icon_image from "../../static/fb_icon.png"
import ig_icon_image from "../../static/ig_icon.png"
import yt_icon_image from "../../static/yt_icon.png"

const Footer = () => {
	return (
		<div id='footer' style={{ height: '10vh', backgroundColor: 'black', textAlign: 'center', marginTop: '0.25rem', marginBottom: '0.25rem', bottom: 0, left: 50, right: 50 }}>
			<img src={fb_icon_image} style={{ height: '90%', display: 'inline-block' }} />
			<img src={ig_icon_image} style={{ height: '90%', display: 'inline-block', marginLeft: '1rem', marginRight: '1rem' }} />
			<img src={yt_icon_image} style={{ height: '90%', display: 'inline-block' }} />
		</div>
	)
}

export default Footer
